export const excludeFalsy = <T>(args: (T | undefined)[]): T[] => {
    return args.filter((arg): arg is T => Boolean(arg))
}
